import React, {PureComponent, Fragment} from 'react';

import {Button, InputItem, List, PlaceHolder, Toast, Badge, WingBlank} from 'antd-mobile';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';
import PublicHeader from './../../components/header';
import history from './../../utils/history';

import './index.scss'
import {bindPhoneActionResult, sendMessageActionResult, memberLogin} from './store/actionCreators';

class Login extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            value: '',
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
            cardNo: '',
            password: ''
        }
        this.bindEvent();
    }

    componentDidMount() {
        let token = Storage.Base.getInstance().get('_loginTk');
        let register = Storage.Base.getInstance().get('register');
        if (token) {
            if (!register) {
                history.push('/bind');
                return;
            }
            history.push('/home?tab=Home');
        }
        let code = Storage.Base.getInstance().get('code');
        if (!code) {
            history.push('/oauth');
        }
    }

    bindEvent() {
        this.memberLogin = this.memberLogin.bind(this);
        this.weChatLogin = this.weChatLogin.bind(this);
    }


    onErrorClick = () => {
        if (this.state.hasError) {
            Toast.info('请输入卡号！');
        }
    }
    onChange = (value) => {
        if (!value) {
            this.setState({
                hasError: false,
            });
        }
        this.setState({
            cardNo: value,
        });
    }

    passChange = (value) => {
        if (!value) {
            this.setState({
                hasError: false,
            });
        }
        this.setState({
            password: value,
        });
    }

    async memberLogin() {

        let code = Storage.Base.getInstance().get('code');
        if (!code) {
            history.push('/oauth');
        }

        const cardNo = this.cardNumRef.state.value;
        const pass = this.passwordRef.state.value;

        if (!cardNo) {
            Toast.info("请输入卡号!");
            return;
        }

        if (!pass) {
            Toast.info("请输入密码!");
            return;
        }

        const data = {
            type: '2',
            cardCode: cardNo,
            password: pass,
            code: code,
        }
        const result = await this.props.memberLogin(data);
        if (!result.data.success) {
            Storage.Base.getInstance().remove('code');
            Toast.fail(result.data.error);
            history.push('/oauth');
            return;
        }
        let storage = Storage.Base.getInstance();
        storage.set("_loginTk", result.data.result.token);
        Storage.Base.getInstance().set("register", result.data.result.register);
        if (!result.data.result.register) {
            window.location.href = `/bind`;
            return;
        }
        window.location.href = `/home`;
    }


    async weChatLogin() {
        let code = Storage.Base.getInstance().get('code');
        if (!code) {
            history.push('/oauth');
        }
        const data = {
            type: '1',
            code: code
        };
        const result = await this.props.memberLogin(data);
        console.log("token info:", result)
        if (!result.data.success) {
            Storage.Base.getInstance().remove('code');
            history.push('/oauth');
            return;
        }
        Storage.Base.getInstance().set("_loginTk", result.data.result.token);
        Storage.Base.getInstance().set("register", result.data.result.register);

        if (!result.data.result.register) {
            window.location.href = `/bind`;
            return;
        }
        history.push("/home")

    }

    render() {
        const {getFieldError} = this.props.form;

        return (
            <Fragment>
                <div className="login-logo"></div>
                <WingBlank size="md">
                    <div style={{marginTop: "10px"}}>
                        <List
                            renderHeader={() => <span style={{color: "#F5A623 "}}>会员登录</span>}
                        >
                        </List>
                        <InputItem
                            type="text"
                            clear
                            name="cardNo"
                            ref={el => this.cardNumRef = el}
                            maxLength="20"
                            placeholder="会员卡号"
                            error={this.state.hasError}
                            onErrorClick={this.onErrorClick}
                            onChange={this.onChange}
                        ></InputItem>

                        <InputItem type="password"
                                   placeholder="密码"
                                   ref={el => this.passwordRef = el}
                                   maxLength="20"
                                   name="password"
                                   style={{borderBottom: "none"}}
                                   onChange={this.passChange}
                        ></InputItem>
                        <div style={{width: '100%', color: '#108ee9', textAlign: 'right', margin: '10px 0'}}>
                            <a style={{paddingRight:"15px"}} onClick={() => {
                                history.push("/forget")
                            }}>忘记密码?</a>
                        </div>

                        <Button style={{
                            backgroundColor: '#F5A623',
                            color: '#FFFFFF',
                            margin: "30px 45px",
                            borderRadius: "41px",
                            height: '45px',
                            lineHeight: '45px'
                        }}
                                onClick={this.memberLogin}>立即登录</Button>
                        <Button style={{
                            backgroundColor: '#FFFFFF',
                            color: '#FD9D24',
                            margin: "5px 45px",
                            borderRadius: '41px',
                            border: "solid #FD9D24 1px",
                            height: '45px',
                            lineHeight: '45px'

                        }}
                                onClick={this.weChatLogin}>非会员订场</Button>
                    </div>
                </WingBlank>
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    userLogin: data => dispatch(bindPhoneActionResult(data)),
    memberLogin: data => dispatch(memberLogin(data)),
    handleSendCode: data => dispatch(sendMessageActionResult(data)),
});

const LoginWapperForm = createForm()(Login);

export default connect(null, mapDispatchToProps)(LoginWapperForm);
